import { defineRule } from 'vee-validate'
import { required, email, numeric } from '@vee-validate/rules'

export default defineNuxtPlugin((nuxtApp) => {
  defineRule('required', required)

  defineRule('email', email)

  defineRule('numeric', numeric)
})
